/* eslint-disable react/prop-types */ // TODO: add props
import { Component } from 'react';

/** Components */
import BaseLayout from './BaseLayout';
import PhysicsKeypad from '../keypads/Physics';

class PhysicsLayout extends Component {
  render() {
    return (
      <div className="keypad-layout chemistry clearfix">
        <BaseLayout {...this.props} />
        <PhysicsKeypad
          onKeyPressWrite={this.props.onKeyPressWrite}
          onKeyPressCmd={this.props.onKeyPressCmd}
        />
      </div>
    );
  }
}

export default PhysicsLayout;
